'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _action_type = require('../constants/action_type');

var initialState = {
  src: false,
  smi: false,
  mass: 0,
  svg: ''
};

var updateConversion = function updateConversion(state, action) {
  var payload = action.payload;
  var mol = payload.mol,
      smi = payload.smi,
      mass = payload.mass,
      svg = payload.svg;

  return Object.assign({}, state, {
    src: mol,
    smi: smi,
    mass: mass,
    svg: svg || ''
  });
};

var molReducer = function molReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _action_type.MOL.CONVERT_DONE:
      return updateConversion(state, action);
    case _action_type.MOL.ADD_FAIL:
    case _action_type.MOL.CONVERT_FAIL:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

exports.default = molReducer;